(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();

(function repairKidsMobileRimPicker() {
  const selector = '.pdl-kids-compact';
  const styleId = 'pdl-kids-mobile-rim-picker-fix';

  const ensureStyle = () => {
    if (document.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .pdl-kids-compact {
        --pdl-yellow: #f8c10e !important;
        --pdl-ellow: #f8c10e !important;
      }

      .pdl-kids-compact__option::after {
        content: '→' !important;
      }
    `;
    document.head.appendChild(style);
  };

  const initializeSection = (section) => {
    if (!(section instanceof HTMLElement)) return;

    section
      .querySelectorAll('a[href="/collections/bicicicletas-infantis-aro-14"]')
      .forEach((link) => link.setAttribute('href', '/collections/bicicletas-infantis-aro-14'));

    section
      .querySelectorAll('.pdl-kids-compact__mobile-picker')
      .forEach((details) => details.setAttribute('data-auto-close-details', 'mobile'));
  };

  const initialize = (root = document) => {
    ensureStyle();

    if (root instanceof Element && root.matches(selector)) initializeSection(root);
    root.querySelectorAll?.(selector).forEach(initializeSection);
  };

  const start = () => {
    initialize(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) initialize(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', () => initialize(document));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
